import { message, Space } from 'antd';
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import ActionBar from '../../../components/action-bar';
import ActionButton from '../../../components/action-button';
import MiniTable from '../../../components/mini-table';
import { Alerta } from '../../../constants';
import useDispatchWithResult from '../../../hooks/useDispatchWithResult';
import useLoading from '../../../hooks/useLoading';
import {
  administradoresAlertaNivelSelector,
  administradoresAlertasSelector,
  administradoresSearchSelector,
  administradoresSelector,
  fetchAdministradores,
  fetchVerificarLimite,
  isEditableSelector,
} from '../../../store/empresa';
import unwrapAxiosPromise from '../../../util/unwrapAxiosPromise';
import { openPopup } from '../../../util/window';
import Alertas from '../_Alertas';
import styles from '../_styles.less';
import EmpresaAdministradoresTable from './_table';
import useModulo from '../../../hooks/useModulo';

export default function EmpresaAdministradoresDetailPage() {
  const miniTableRef = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const nivel = useSelector(administradoresAlertaNivelSelector);
  const isEditable = useSelector(isEditableSelector);
  const administradores = useSelector(administradoresSelector);
  const search = useSelector(administradoresSearchSelector);
  const alertas = useSelector(administradoresAlertasSelector);
  const loading = useLoading(fetchAdministradores.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const { moduloBasePath } = useModulo();
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleSearch = (search) => {
    dispatch(fetchAdministradores({ empresaId, search }));
  };

  const handleCreate = () => {
     unwrapAxiosPromise(dispatch(fetchVerificarLimite()))
        .then(() => {
           history.replace(`${moduloBasePath}/empresas/${empresaId}/administradores/create`);
        })
  };

  const handleRemove = () => {
    setLoadingRemove(true);
    unwrapAxiosPromise(
      axios.delete(`/empresas/${empresaId}/administradores`, {
        params: { ids: selectedIds },
      })
    )
      .then(() => {
        message.success(t('Registro(s) removido(s) com sucesso'));
        setSelectedIds([]);
        dispatch(fetchAdministradores({ empresaId }));
      })
      .finally(() => setLoadingRemove(false));
  };

  const handleDetail = (administrador) => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/administradores/${administrador.id}`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/administradores/`, `logs_/empresas/${empresaId}/administradores/`);
  };

  const actions = [];
  if (isEditable) {
    actions.push(<ActionButton.Create disabled={isNA} onClick={handleCreate} />);
    actions.push(<ActionButton.Remove disabled={selectedIds.length === 0 || isNA} onClick={handleRemove} loading={loadingRemove} />);
  }
  actions.push(<ActionButton.Logs noTitle onClick={handleLogs} />);
  actions.push(<MiniTable.DownloadButton disabled={loading || administradores.length === 0} miniTableRef={miniTableRef} />);
  const title = () => (
    <ActionBar search={search} onSearch={handleSearch}>
      {actions}
    </ActionBar>
  );
  return (
    <Space direction="vertical" className={styles['space-2']}>
      <EmpresaAdministradoresTable
        dataSource={administradores}
        loading={loading}
        miniTableRef={miniTableRef}
        onClick={handleDetail}
        onSelectedIdsChange={setSelectedIds}
        selectedIds={selectedIds}
        title={title}
      />
      <Alertas alertas={alertas} />
    </Space>
  );
}

EmpresaAdministradoresDetailPage.propTypes = {
  administradores: PropTypes.array,
  onCreate: PropTypes.func,
  onRemove: PropTypes.func,
};
